import gql from 'graphql-tag'

import { LeadFieldsFragment } from './lead'

export const LEAD_UNBOOKMARK_MUTATION = gql`
  mutation LeadUnbookmark($schoolId: Int!) {
    lead: leadUnbookmark(schoolId: $schoolId) {
      ...LeadFields
    }
  }

  ${LeadFieldsFragment}
`
